import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import journryCard30 from "../../../assets/images/trialMode/journryCard30.png";
import journryCard70 from "../../../assets/images/trialMode/journryCard70.png";
import journryCard100 from "../../../assets/images/trialMode/journryCard100.png";
import cn from "../../../utils/cn";
import getCharacterSrc from "./utils/getCharacterSrc";
import { JourneyCardType } from "./types";

export function TemplatePreview({
  data,
  className,
}: {
  data: JourneyCardType;
  className?: string;
}) {
  const {
    greeting,
    experiencePromotionWording,
    experienceNavigationWording,
    experienceCharacter,
    isDisplayVideo,
    videoWording,
  } = data;

  return (
    <div
      className={cn(
        "w-[390px] h-[220px] py-2 flex flex-col bg-gradient-to-r from-[#FFFFFF] to-[#E0F0FA] text-black",
        className
      )}
      style={{
        backgroundImage: `url(${data.segmentation === "Awareness" ? journryCard30
          : data.segmentation === "Interest" ? journryCard70
          : journryCard100
          })`,
      }}
    >
      <div className="flex justify-between items-center h-[100px] px-4">
        <h2 className="font-semibold text-[17px] leading-6">
          {greeting && greeting.replace("{User's Name}", "Ms. Lee")}
        </h2>

        {isDisplayVideo ? (
          <div className="flex justify-center items-center gap-1 border border-solid border-[#D0E7FF] bg-white px-3 py-2 rounded-full cursor-pointer">
            <p className="text-xs text-[#666666] font-medium">{videoWording}</p>
            <div className="w-4 h-4 rounded-full bg-[#0BBEFF] flex justify-center items-center">
              <CaretRightOutlined className="text-white text-[10px]" />
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>

      <div className="min-h-16 flex justify-between items-center gap-2 mt-auto mb-[-10px] px-4 py-[10px] text-[12px]">
        <div className="flex items-center gap-[6px]">
          {experienceCharacter && experienceCharacter !== "None" ? (
            <img
              className="custom-avatar w-11 h-11"
              src={getCharacterSrc(experienceCharacter)}
              alt={experienceCharacter}
            />
          ) : null}

          <div>
            {experiencePromotionWording.split("\n").map((text, index) => (
              <p key={index} className="leading-5">
                {text}
              </p>
            ))}
          </div>
        </div>

        <div className="flex flex-row justify-end items-center gap-1 cursor-pointer">
          <div className="flex w-fit flex-row rounded-full bg-[#FF5D55] text-[#ffffff] px-2 py-1 whitespace-nowrap">
            <div>
              {experienceNavigationWording.split("\n").map((text, index) => (
                <p key={index} className="leading-5">
                  {text}
                </p>
              ))}
            </div>

            <RightOutlined style={{ color: 'white' }} />
          </div>
        </div>
      </div>
    </div>
  );
}
